import request from '@/utils/request'

// 分页查询班级
export function reqClassPage(data) {
    return request({
        url: '/education/class/page',
        method: 'post',
        data
    })
}

// 根据年级ID获取班级列表（不分页）
export function reqClassList(params) {
    return request({
        url: '/education/class/list',
        method: 'get',
        params
    })
}

// 查询班级详情
export function reqClassDetail(id) {
    return request({
        url: '/education/class/detail',
        method: 'get',
        params: { id }
    })
}

// 新增班级
export function reqClassInsert(data) {
    return request({
        url: '/education/class/insert',
        method: 'post',
        data
    })
}

// 更新班级
export function reqClassUpdate(data) {
    return request({
        url: '/education/class/update',
        method: 'post',
        data
    })
}

// 删除班级
export function reqClassDelete(id) {
    return request({
        url: '/education/class/delete',
        method: 'get',
        params: { id }
    })
}

// 批量新增班级
export function reqClassBatchInsert(data) {
    return request({
        url: '/education/class/batchInsert',
        method: 'post',
        data
    })
}
